import { gql, TypedDocumentNode } from '@apollo/client'

import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { DomainBidderDTO } from 'features/globalSetup/api/types/domainBidderDTO'

export const DOMAIN_BIDDER_FOR_SELECT_FRAGMENT: TypedDocumentNode<DomainBidderDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment DomainBidderForSelectFragment on DomainBidder {
    id
    domain {
      id
      alerts {
        ...AlertFragment
      }
      name
    }
  }
`
